import { index, integer, pgTable, serial, text, timestamp } from 'drizzle-orm/pg-core'
import { user } from './user'

export const offer = pgTable(
  'offer',
  {
    id: serial('id').primaryKey(),
    created: timestamp().defaultNow().notNull(),
    updated: timestamp().defaultNow().notNull(),
    externalOfferId: text('external_offer_id').notNull().unique(),
    ownerId: integer('owner_id')
      .references(() => user.id)
      .notNull(),
  },
  (table) => [index('offer_owner_id_idx').on(table.ownerId)]
)

export type Offer = typeof offer.$inferSelect
export type InsertOffer = typeof offer.$inferInsert
